export default __webpack_public_path__ + "static/media/staring-computer.9e07a64b.png";